import { sectionTpl } from './section';
import { panelTpl } from './panel';

export { sectionTpl, panelTpl }